import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { UIProvider } from './shared/UI/Uicontext';
import { useAuthKey } from './store/api/authKey';
import { AuthKeyContext } from './shared/context/AuthKeyContext';
import { AppDispatch } from './store';
import { loadSession, clearSession } from './store/slices/sessionSlice';
import {
  decodeSessionFromStorage,
  refreshTokenExpiry,
  isSessionExpired,
} from './shared/services/userSessionService';
import './App.scss';

function App() {
  const { isAuthKeyReady } = useAuthKey();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSessionExpired()) {
      dispatch(clearSession());
      navigate('/', { replace: true });
      return;
    }
    const session = decodeSessionFromStorage();
    if (session) dispatch(loadSession(session));
  }, [dispatch, navigate]);

  useEffect(() => {
    const interval = setInterval(
      () => {
        if (!isSessionExpired()) {
          refreshTokenExpiry();
        }
      },
      60 * 60 * 1000
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <AuthKeyContext.Provider value={isAuthKeyReady}>
      <UIProvider>
        <AppRoutes />
      </UIProvider>
    </AuthKeyContext.Provider>
  );
}

export default App;
